import { moveToFulfilled, update } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import {
  DesignateLeaderFulfilledAction,
  LeaderLoadFulfilledAction,
  RevokeLeaderFulfilledAction,
  UpdateHasMultiTenantWideAudienceFulfilledAction,
  UpdateHasNetworkWideAudienceFulfilledAction,
  UserNetworkLeadersListLoadAction,
  UserNetworkLeadersListLoadMoreAction,
} from '../../domains/leadersManagement/actions.types';
import { TypeaheadFulfilledAction } from '../../domains/typeahead/actions.types';

import { UserNetworkLeaders } from './types';

export type UserNetworkLeadersAction =
  | TypeaheadFulfilledAction
  | DesignateLeaderFulfilledAction
  | UserNetworkLeadersListLoadAction
  | RevokeLeaderFulfilledAction
  | UserNetworkLeadersListLoadMoreAction
  | UpdateHasNetworkWideAudienceFulfilledAction
  | UpdateHasMultiTenantWideAudienceFulfilledAction
  | LeaderLoadFulfilledAction;

const initialState: UserNetworkLeaders = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<UserNetworkLeaders, UserNetworkLeadersAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'ALL_LEADERS_IN_USERS_NETWORK.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.userNetworkLeaders);
    case 'ALL_LEADERS_IN_USERS_NETWORK.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.userNetworkLeaders);
    case 'TYPEAHEAD.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.userNetworkLeaders);
    case 'LEADER.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.userNetworkLeaders);
    case 'DESIGNATE_LEADER.FULFILLED':
      return update(state, action.payload.userId, action.payload.leaderEntity);
    case 'REVOKE_LEADER.FULFILLED':
      return update(state, action.payload.userId, action.payload.leaderEntity);
    case 'UPDATE_HAS_NETWORK_WIDE_AUDIENCE.FULFILLED':
      return update(state, action.payload.userId, {
        hasNetworkWideAudience: action.payload.hasNetworkWideAudience,
        hasMultiTenantWideAudience: action.payload.hasMultiTenantWideAudience,
      });
    case 'UPDATE_HAS_MULTI_TENANT_WIDE_AUDIENCE.FULFILLED':
      return update(state, action.payload.userId, {
        hasMultiTenantWideAudience: action.payload.hasMultiTenantWideAudience,
      });
    default:
      return state;
  }
};

export default reducer;
